import {useEffect, useState, useCallback} from "react";
import general from "../../../general";
import {NavLink} from "../../../lib/Navigation";
import moment from "moment";
import Dialog from "../../../lib/Dialog";
import Image from "../../../lib/Image";
import {useUpdate} from "ahooks";
import Explain from "../../voucher/Explain";
import useUrlState from "@ahooksjs/use-url-state";
import useActiveState from "../../../lib/useActiveState";
import XHInfo from "../../components/alert/XHInfo";
import SelectAccount, { useSelectAccount } from "../../components/alert/SelectAccount";
import { showDownloadGameAlert } from "../../components/alert/XHModalShow";
export default props => {
  const [game] = useState(general.game);
  const [explain, setExplain] = useState();
  const [params, setParams] = useUrlState({}, {navigateMode: 'replace'});
  const [data, setData] = useState();
  const [user, setUser] = useActiveState('user');
  const [remindState, setRemindState] = useState(false);
  const [init, setInit] = useState(false);
  const [loading, setLoading] = useState(false);
  const {appendTopic_id,visibleChange} = useSelectAccount()
  const [xh,setXH] = useState({})  
  const [xhList,setXHList] = useState([])  
  const [xhinit, setXHInit] = useState(false)
  const [receiveCount,setReceiveCount] = useState(0)
  const [topic_id,setTopic_id] = useState('')
  const update = useUpdate();
  const receive = voucher => {
    if (xhList.length == 0) {
      showDownloadGameAlert().then(()=>{
        general.history.goBack()
      })
      return
    }

    if(voucher.vip_level > 0 && user.vip_level == '') {
      setRemindState(true);
      return;
    }

    general.axios.post('/user/voucher2504/receiveVoucher', {voucher_id: voucher.id,trumpet_name:xh.xh_username})
      .finally(() => {
        Dialog.close();
      })
      .then(res => {
        let {status, data} = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
        } else {
          let available_voucher = (parseInt(user.available_voucher) + 1).toString();
          setUser({...user, ...{available_voucher: available_voucher}});
          Dialog.success('领取成功');
          // voucher.is_received = true;
          // update();

          if(!data.hasSome) {
            voucher.is_received = true;
            update();
          }
        }
      })
      .catch(err => {
        Dialog.error(err.message);
      });
  }

  const load = () => {
    if (loading){
      return
    }
    setLoading(true)
    general.axios.post('/user/voucher2504/getVouchers', {game_id: params.id,trumpet_name:xh?.xh_username})
      .finally(() => {
        // Dialog.close();
        setLoading(false)
      })
      .then(res => {
        let {status, data} = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
        } else {
          setInit(true)
          setData(data.list);
          setReceiveCount(data.count);
        }
      })
      .catch(err => {
        Dialog.error(err.message);
      });
    
  }

  useEffect(()=>{
    if(props.active) {
      setInit(true)
    }
  }, [props.active]);

  const ref = useCallback(node => {
    if (node) {
      node.addEventListener('touchstart', e => {
        e.stopPropagation();
      }, {passive: false});
      node.addEventListener('touchmove', e => {
        e.stopPropagation();
      }, {passive: false});
      node.addEventListener('touchend', e => {
        e.stopPropagation();
      }, {passive: false});
    }
  }, []);

  useEffect(()=>{
    if (init){
      setTopic_id(appendTopic_id(game.maiyou_gameid))
    }
  },[init])

  useEffect(()=>{
    if (props.active && xh.xh_username){
      load();
    }
  },[xh,props.active])

  const handleRequetXHData = (xhlist)=>{
    setXHList(xhlist)
    setXHInit(true)

    if (xhlist.length == 0){
      load()
    }
    xhlist.forEach(item=>{
      if (item.is_default){
        setXH(item)
      }
    })
  }

  const handleCompletion = (xhinfo)=>{
    setXH(xhinfo)
  }

  const receiveAll = ()=>{
    if (xhList.length == 0){
      showDownloadGameAlert()
      return
    }
    general.axios.post('/oneClickReceiveVoucher', {appid: params.id,trumpet_name:xh.xh_username})
      .then(res => {
        let {status, data} = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
          return;
        }
        Dialog.info('领取成功')
        load()
      })
      .catch(err => {
        Dialog.error(err.message);
      });
  }

  return <div className="game-coupon-index" >
    <SelectAccount topic_id={topic_id} handleRequetXHData={handleRequetXHData} handleCompletion={handleCompletion}></SelectAccount>
    <div className="game-voucher">
      <div className="container" style={{padding: xhList.length != 1 && xhinit ? ' 40px 10px 0 10px' : '0 10px 0 10px'}}>
        {xhList.length != 1 && xhinit && <XHInfo title='代金券' xh={xh} list={xhList} change={()=>{
          visibleChange(true,topic_id)
        }} selectAccountInfo={xh} xhList={xhList}></XHInfo>}
        {/* {game?.game_info?.game_species_type != '2' && game?.game_info?.game_species_type != '3' ?
        // <NavLink to="/save?type=card" className="tips">
        <NavLink to="/save/newcard" className="tips">
          <div className="icon"><img src="/resources/game/voucher-icon3.png" alt=""/></div>
          <div className="name">四倍返还</div>
          <div className="info">开通立返全额 每天领5元</div>
          <div className="operate">></div>
        </NavLink>
        : null} */}

        <div className="body" ref={ref} style={{paddingBottom:(receiveCount > 1 ? '70px' : '0')}}>
          {data?.map((voucher,index) => <div key={`${xh.xh_username}-${index}`} className="item" style={{backgroundImage: voucher.vip_level ? voucher.vip_level > 0 ? ('url(/resources/game/vouch-bag.png)') : ('url(/resources/game/vouch-bag.png)') :('url(/resources/game/vouch-bag.png)')}}>
            {/* <div className={"amounts " + (voucher.vip_level ? voucher.vip_level > 0 ? "vip-amounts" : "" : "")}> */}
            <div className={"amounts " }>
              {/* {
                voucher.vip_level ? 
                  voucher.vip_level > 0 ?
                  <div className="vip-label">
                    <img src="/resources/game/vip-label.png" />
                    <div className="text">
                      {voucher.vip_level_desc}
                    </div>
                  </div>
                  :null
                :null
              } */}
              <div className="receive-count" 
                   style={{backgroundImage:'url(/resources/game/receive-count.png)'}}>
                   {voucher.receiveMaxDesc}
              </div>
              <div className="amount">
                <div className="amount-unit">￥</div>
                <div>{voucher.amount * 1}</div>
              </div>
              <div className="amount-meet">
              {voucher.rules_used}
              </div>
            </div>
            <div className="info">
              <div className="name">{voucher.vname}</div> 
              <div className="row-info">
                <div className="vip" style={{display:voucher.vip_level > 0 ? '' : 'none'}}>VIP专享</div>
                <div className="sing-voucher">{voucher.label}</div>
                <div className="time">{voucher.useEndDateTime}</div>
              </div>
              {/** <div className="game">仅限《{voucher.game_name}》</div> */}
              <div className={"use " + (voucher.vip_level ? voucher.vip_level > 0 ? "vip-use" : "" : "")} onClick={() => setExplain(voucher)}>使用方法{'>'}</div>
            </div>
            {voucher.is_received != '0'
              ? <div className="operate disable">已领取</div>
              : 
              // <NavLink className={"operate " + (voucher.vip_level ? voucher.vip_level > 0 ? "vip-operate" : "" : "")} onClick={() => receive(voucher)}>立即领取</NavLink>
              <NavLink className={"operate " } onClick={() => receive(voucher)}>立即领取</NavLink>
              }
          </div>)}
        </div>

        {receiveCount > 1 && <div className="receive">
          <div className="content" onClick={receiveAll}>一键领取{receiveCount}张代金券</div>
        </div>}
      </div>
      {explain ? <Explain voucher={explain} setVoucher={setExplain}/> : null}
    </div>

    {/** 领取弹框提示 **/}
    {remindState ?
    <div className="vip-remind-index">
      <div className="remind-site">
        <div className="remind-main">
          <div className="close" onClick={()=>setRemindState(false)}>
            <img src="/resources/user/close.png" />
          </div>
            <div className="remind-title">
            温馨提示
            </div>
            <div className="info">
              <p>仅限会员可领取</p>
            </div>
            <div className="remind-btn">
              <NavLink to="/save/newvip" className="item btn-confirm" onClick={()=>setRemindState(false)}>
                开通会员
              </NavLink>
            </div>
        </div>
      </div>
    </div>
    : null}

  </div>;
};